export default __webpack_public_path__ + "static/media/client17.36acc746.png";